export default __webpack_public_path__ + "8322970c27a2420858bb7451e34d1f08.svg";